import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FormValidatorUtil, VALID_NAME_FORM_REGEX} from '../../common/form-validator.util';
import {APP_CONFIG} from '../../api/config/app.config';
import {IAppConfig} from '../../store/interfaces/IAppConfig';
import {SiteURL, SiteURLUtils} from '../../common/site.url.utils';
import {ManageStayDelegate} from "../../api/delegates";
import { ActivatedRoute } from '@angular/router';

const CONFIRMATION_NUMBER_FIELD = 'confirmationNumber';
const LAST_NAME_FIELD = 'lastName';

@Component({
  selector: 'hotel-reservation-search',
  templateUrl: './hotel-reservation-search.component.html',
  styleUrls: ['./hotel-reservation-search.component.scss']
})
export class HotelReservationSearchComponent implements OnInit {
  @Input() messages;

  formUrl: string;
  form: FormGroup;
  confirmationNumber: string;
  lastName: string;

  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private _manageStayDelegate: ManageStayDelegate,
    private _activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      if (params['id'] && params['lastName']) {
        this.confirmationNumber = params['id'];
        this.lastName = params['lastName'];

        this.searchReservation();
      }
    });

    this.formUrl = SiteURLUtils.getLocalizedSiteUrl(this.appConfig, SiteURL.RESERVATION_VIEW);
    this.form = new FormGroup({
      confirmationNumber: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(VALID_NAME_FORM_REGEX)])
    }, {validators: FormValidatorUtil.checkBothRequired(CONFIRMATION_NUMBER_FIELD, LAST_NAME_FIELD)});
  }

  searchReservation() {
    this._manageStayDelegate.retrieveReservation(this.confirmationNumber, this.lastName);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-reservation-search/hotel-reservation-search.component.ts